import { MarginPosition, MarginPositionStatus } from '@swyftx/margin/build/types';

import { Big } from '@shared/safe-big';

import { create } from 'zustand';

type MarginPositionsState = {
  positions: Map<string, MarginPosition>;
  updatePositions: (newPositions: MarginPosition[]) => void;
};

const useMarginPositionsStore = create<MarginPositionsState>()((set) => ({
  positions: new Map<string, MarginPosition>(),
  updatePositions: (newPositions: MarginPosition[]) => {
    set(({ positions }) => {
      const newPositionsMap: Map<string, MarginPosition> = new Map(positions);

      newPositions.forEach((p) => {
        if (
          [MarginPositionStatus.Cancelled, MarginPositionStatus.Closed, MarginPositionStatus.Reject].includes(p.status)
        ) {
          newPositionsMap.delete(p.positionId);
        } else {
          const currentPosition = newPositionsMap.get(p.positionId);

          if (Big(currentPosition?.lastUpdate || 0).gt(p.lastUpdate || 0)) return;

          newPositionsMap.set(p.positionId, { ...currentPosition, ...p });
        }
      });

      return { positions: newPositionsMap };
    });
  },
}));

export { useMarginPositionsStore };
